import { boot } from "@kit/boot";
import { game } from "./index";

boot({ id: game.meta.id, scenes: game.scenes, background: 0x0d1931 });
